const mtcount = {
  state: () => ({
    privateCnt: null,
    workspaceCnt: null,
    assignedCnt: null,
  }),
  mutations: {
    setPrivateCnt(state, privateCnt) {
      state.privateCnt = privateCnt
    },
    setWorkspaceCnt(state, workspaceCnt) {
      state.workspaceCnt = workspaceCnt
    },
    setAssignedCnt(state, assignedCnt) {
      state.assignedCnt = assignedCnt
    },
  },
  actions: {
    // private cnt 설정
    setPrivateCnt({ commit }, privateCnt) {
      if (privateCnt >= 0) commit('setPrivateCnt', privateCnt)
    },
    // workspace cnt 설정
    setWorkspaceCnt({ commit }, workspaceCnt) {
      if (workspaceCnt >= 0) commit('setWorkspaceCnt', workspaceCnt)
    },
    // assigned cnt 설정
    setAssignedCnt({ commit }, assignedCnt) {
      commit('setAssignedCnt', assignedCnt)
    },
    setUnreadCnt({ commit }, result) {
      if (result.privateCnt >= 0) commit('setPrivateCnt', result.privateCnt)
      if (result.workspaceCnt >= 0) commit('setWorkspaceCnt', result.workspaceCnt)
      if (result.assignedCnt >= 0) commit('setAssignedCnt', result.assignedCnt)
    },
  },
  getters: {
    privateCnt(state) {
      return state.privateCnt
    },
    workspaceCnt(state) {
      return state.workspaceCnt
    },
    assignedCnt(state) {
      return state.assignedCnt
    },
  },
}

export default mtcount
